import {UIRouterReact,  servicesPlugin, pushStateLocationPlugin} from '@uirouter/react'
import states from 'router/states'
import {RouterStates} from 'router/states/routerStates.enum'

// Instantiate the Router
const router = new UIRouterReact()
// router.plugin(servicesPlugin)
// router.plugin(pushStateLocationPlugin)
// router.plugin(memoryLocationPlugin)

// load ui router visualizer
if(__WEBPACK_ISDEV__) {
  const options = {
    state: UI_ROUTER_SHOW_STATES,
    transition: UI_ROUTER_SHOW_TRANSITIONS,
  }

  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const Visualizer = require('@uirouter/visualizer').Visualizer
  router.plugin(Visualizer, options)
}

// Global config for router
router.urlService.rules.initial({state: RouterStates.home})
router.urlService.rules.otherwise({state: RouterStates.home})

const plugins = [
  servicesPlugin,
  pushStateLocationPlugin,
]

export default {
  router,
  states,
  plugins,
}
